export default class MembershipNumber {
    constructor() {
        this.counter = null;
        this.digits = null;
        this.prefix = null;
        this.suffix = null;
        this.generated = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const membershipNumber = new MembershipNumber();
        membershipNumber.counter = data.counter;
        membershipNumber.digits = data.digits;
        membershipNumber.prefix = data.prefix;
        membershipNumber.suffix = data.suffix;
        membershipNumber.generated = data.generated;

        return membershipNumber;
    }

    clone() {
        const membershipNumber = new MembershipNumber();
        membershipNumber.counter = this.counter;
        membershipNumber.digits = this.digits;
        membershipNumber.prefix = this.prefix;
        membershipNumber.suffix = this.suffix;
        membershipNumber.generated = this.generated;

        return membershipNumber;
    }

    toString() {
        if (this.counter === null) {
            return '';
        }
        return (this.prefix !== null ? this.prefix : '')
            + this.pad(this.counter, this.digits)
            + (this.suffix !== null ? this.suffix : '');
    }

    pad(str, max) {
        str = str.toString();
        return str.length < max ? this.pad(`0${str}`, max) : str;
    }
}
